import React from 'react'
import style from './articles.style'

const CallTracingBy = ({classes}) => {
  return (
    <article className={classes.article}>
      <h2>Подключение call-tracking.by</h2>

      <ol>
        <li>
          Настройка авторизации
          <figure className={classes.helpArticleFigure}>
            <img src="/images/calltrackingby/calltracinngby1.jpg" alt="true"/>
            <figcaption>Скопируйте уникальный ключ сгенерированный ROMI center<br/> и перейдите в ваш личный кабинет в
              call-tracking.by.
            </figcaption>
          </figure>
        </li>

        <li>
          В личном кабинете call-tracking.by, перейдите в раздел “Настройки”.
          <figure className={classes.helpArticleFigure}>
            <img src="/images/calltrackingby/callby2.png" alt="true"/>
          </figure>
        </li>

        <li>
          В разделе “Доступные для подключения интеграции”, выберите API.
          <figure className={classes.helpArticleFigure}>
            <img src="/images/calltrackingby/call3.png" alt="true"/>
          </figure>
        </li>

        <li>
          Во вкладке <b>“Основные”</b>, в строке <b>Вебхук уведомление при начале звонка</b>.
          <ol>
            <li>Выберите метод POST</li>
            <li>В строку <b>“Полный адрес для уведомления…”</b> вставьте адрес</li>
            <li>API: https://romi.center/api/calltracking/call_tracking_by</li>
          </ol>
          <figure className={classes.helpArticleFigure}>
            <img src="/images/calltrackingby/call4.png" alt="true"/>
          </figure>
        </li>

        <li>
          На второй вкладке “Дополнительно” укажите в поле “Дополнительные параметры для отправки” значение
          romi_user_hash.
          <figure className={classes.helpArticleFigure}>
            <img src="/images/calltrackingby/call5.png" alt="true"/>
            <figcaption>Нажмите кнопку <b>“Сохранить”</b>.</figcaption>
          </figure>
        </li>

        <li>
          Подключение коллтрекинга завершено.
          <ol>
            <li>Мы создали цель incoming_call в вашем google analytics.</li>
            <li>Вы можете использовать ее для анализа как в google analytics, так и в отчетах в личном кабинете ROMI
              center.
            </li>
          </ol>
        </li>
      </ol>
    </article>
  )
}

export default style(CallTracingBy)
